import React from 'react';
import ScoreTarget from './ScoreTarget';
import Priority from './Priority';

export default () => {
  return (
    <>
      <div className="text-gray-700 pt-8 pb-10">
        <div className="text-base font-bold">ToDo作成の設定</div>
        <div className="text-sm">
          顧客スコア変動履歴が作成されるタイミングでSalesforceのToDoを作成します。
        </div>
      </div>

      <div className="space-y-6">
        <div className="flex items-center text-gray-700">
          <label className="w-24 mr-5 font-bold ">タイトル</label>
          <span>「スコアA_リード名」の形式で自動生成されます。</span>
        </div>
        <ScoreTarget />
        <div className="flex items-center text-gray-700">
          <label className="w-24 mr-5 font-bold ">日付</label>
          <span>スコア変動日から1日後</span>
        </div>
        <div className="flex items-center text-gray-700">
          <label className="w-24 mr-5 font-bold ">担当者</label>
          <span>
            該当リードのSalesforce所有者を担当者に設定します。
          </span>
        </div>
        <Priority />
      </div>
    </>
  );
};
